export enum ServiceOption {
    Success = "200",
    Accepted = "202",
    BadRequest = "400",
    BadGateway = "500"
}